/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Interactions Hooks
 *
 * Barrel export for all interaction-related hooks
 */

// PERFORMANCE: Explicit exports instead of export * for better tree-shaking

// Auto-expand navigation section
export { useAutoExpandNavigationSection } from "./use-auto-expand-navigation-section";

// Keyboard shortcuts
export type {
  ShortcutConfig,
  SequentialShortcutConfig,
} from "./use-keyboard-shortcuts";
export {
  useKeyboardShortcuts,
  useSequentialKeyboardShortcuts,
  formatShortcutKeys,
  globalShortcuts,
  shortcutCategories,
} from "./use-keyboard-shortcuts";

// Tabs
export type {
  UseTabsOptions,
  UseTabsReturn,
  UseClientTabsOptions,
  UseClientTabsReturn,
} from "./use-tabs";
export { useTabs } from "./use-tabs";
